const rotateLeft = (value: number, shift: number) => {
  return ((value << shift) | (value >>> (32 - shift))) >>> 0
}

const add32 = (...values: number[]) => {
  return values.reduce((sum, value) => (sum + (value >>> 0)) >>> 0, 0)
}

const toHex = (value: number) => {
  let result = ''
  for (let i = 0; i < 4; i++) {
    result += ((value >>> (i * 8)) & 0xff).toString(16).padStart(2, '0')
  }
  return result
}

export const md5 = (input: string) => {
  const bytes = new TextEncoder().encode(input)
  const paddedLength = (((bytes.length + 8) >>> 6) + 1) << 6
  const buffer = new Uint8Array(paddedLength)
  buffer.set(bytes)
  buffer[bytes.length] = 0x80

  const view = new DataView(buffer.buffer)
  const bitLength = bytes.length * 8
  view.setUint32(paddedLength - 8, bitLength & 0xffffffff, true)
  view.setUint32(paddedLength - 4, Math.floor(bitLength / 0x100000000), true)

  let a0 = 0x67452301
  let b0 = 0xefcdab89
  let c0 = 0x98badcfe
  let d0 = 0x10325476

  const shifts = [
    7, 12, 17, 22, 7, 12, 17, 22, 7, 12, 17, 22, 7, 12, 17, 22,
    5, 9, 14, 20, 5, 9, 14, 20, 5, 9, 14, 20, 5, 9, 14, 20,
    4, 11, 16, 23, 4, 11, 16, 23, 4, 11, 16, 23, 4, 11, 16, 23,
    6, 10, 15, 21, 6, 10, 15, 21, 6, 10, 15, 21, 6, 10, 15, 21
  ]
  const constants = Array.from({ length: 64 }, (_, index) => {
    return Math.floor(Math.abs(Math.sin(index + 1)) * 0x100000000) >>> 0
  })

  for (let offset = 0; offset < paddedLength; offset += 64) {
    const words = Array.from({ length: 16 }, (_, index) => {
      return view.getUint32(offset + index * 4, true)
    })
    let a = a0
    let b = b0
    let c = c0
    let d = d0

    for (let i = 0; i < 64; i++) {
      let f: number
      let g: number

      if (i < 16) {
        f = (b & c) | (~b & d)
        g = i
      } else if (i < 32) {
        f = (d & b) | (~d & c)
        g = (5 * i + 1) % 16
      } else if (i < 48) {
        f = b ^ c ^ d
        g = (3 * i + 5) % 16
      } else {
        f = c ^ (b | ~d)
        g = (7 * i) % 16
      }

      const next = d
      d = c
      c = b
      b = add32(b, rotateLeft(add32(a, f, constants[i], words[g]), shifts[i]))
      a = next
    }

    a0 = add32(a0, a)
    b0 = add32(b0, b)
    c0 = add32(c0, c)
    d0 = add32(d0, d)
  }

  return [a0, b0, c0, d0].map(toHex).join('')
}
